import { models } from '@ps/web-core-store';

import type { SelectorCreator, Slicer } from '@swf/core/store';
import countries from '@swf/generated/countries.json';
import states from '@swf/generated/states.json';

import type { AccountState } from './index';

const selectors = (slice: Slicer<AccountState>, createSelector: SelectorCreator) => ({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ...models.account.selectors(slice as any, createSelector),
  getFullPlaceOfBirth() {
    return slice((state) => {
      const { countryOfBirth, stateOfBirth, cityOfBirth } = state.placeOfBirthInfo || {};
      const countryStates = countryOfBirth && states[countryOfBirth];
      const countryName =
        (countries as { value: string; text: string }[]).find(
          ({ value }) => value === countryOfBirth
        )?.text || '';
      let countryState = '';
      if (stateOfBirth)
        countryState =
          (countryStates as { value: string; text: string }[])?.find(
            ({ value }) => value === stateOfBirth
          )?.text + ',';
      return [cityOfBirth + ',', countryState, countryName].join(' ');
    });
  },
  getFullAddress() {
    return slice((state) => {
      const { addr1, addr2, city, zipCode, country, state: stateCode } = state;
      const countryStates = country && states[country];
      const countryName = (countries as { value: string; text: string }[]).find(
        ({ value }) => value === country
      )?.text;
      let countryState = '';
      if (stateCode)
        countryState =
          (countryStates as { value: string; text: string }[])?.find(
            ({ value }) => value === stateCode
          )?.text + ',';
      return [addr1, addr2, city + ',', countryState, zipCode, countryName].join(' ');
    });
  }
});

export default selectors;
